import styled from 'styled-components';

export const Container = styled.div`
	margin-top: 15px;
`;

export const Section = styled.div`
	padding: 10px;
	border-radius: 10px;
	background-color: rgba(0, 0, 45, 0.03);
	margin-bottom: 10px;
`;

export const SectionHeader = styled.div`
	display: flex;
	align-items: flex-end;
	gap: 5px;
`;

export const Row = styled.div`
	display: flex;
	align-items: flex-end;
	gap: 5px;
	margin-top: 5px;
`;
